module.exports = __webpack_public_path__ + "img/multi.4951441a.png";